import type { RouteRecordRaw } from 'vue-router'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'

export const userAccountsSubAccountsRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.subAccounts',
  'sub-accounts',
  UserSettingsRoutes.WorkspaceIndex,
)

export const userAccountsUsersRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.users',
  'users',
  UserSettingsRoutes.WorkspaceIndex,
)

export const userAccountsDataRetentionRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.dataRetention',
  'data-retention',
  UserSettingsRoutes.WorkspaceDataRetention,
)

export const userAccountsMyDataRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.myData',
  'my-data',
  UserSettingsRoutes.WorkspaceDataRetention,
)
